var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medium-light@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4EA4\\u6613",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18 L18,18 L18,0 L0,0 L0,18 Z M14.9544434,4.2629907 L13.9901842,5.18702122 C13.9058344,5.25135707 13.8656057,5.35582121 13.8817022,5.4562675 L13.8817022,12.258465 C13.8656057,12.3629292 13.9058344,12.4673933 13.9901842,12.527636 L14.9343291,13.4517669 L14.9343291,13.6566774 L10.1933396,13.6566774 L10.1933396,13.4598027 L11.1696524,12.5115395 C11.2660808,12.415111 11.2660808,12.3870614 11.2660808,12.2423936 L11.2660808,6.74195488 L8.54998807,13.636563 L8.18441381,13.636563 L5.02231442,6.74195488 L5.02231442,11.3624841 C4.99416435,11.555341 5.06254316,11.7522157 5.19907478,11.8928908 L6.4687912,13.4316526 L6.4687912,13.636563 L2.86076052,13.636563 L2.86076052,13.4316526 L4.13035138,11.8928908 C4.26700856,11.7522157 4.32722611,11.555341 4.29505818,11.3624841 L4.29505818,6.0187416 C4.3111547,5.87013132 4.25492989,5.72543844 4.14243005,5.62499215 L3.01338865,4.2629907 L3.01338865,4.05808028 L6.52097305,4.05808028 L9.22900498,10.0044001 L11.6115407,4.06209813 L14.9544434,4.06209813 L14.9544434,4.2629907 Z",
    id: "medium-light",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumLight);
export default __webpack_public_path__ + "static/media/medium-light.56600d3c17cd5334849687d43aa7f671.svg";
export { ForwardRef as ReactComponent };